import { createApiClientContext } from '@wix/package-picker-shared';
const upgradeApiClientContext = {};
export const UpgradeApiClientContext = createApiClientContext(upgradeApiClientContext);
//# sourceMappingURL=upgrade.context.js.map